import _ from 'lodash'
import { getCurrentPortalDisplayAppId, getSortedAppInstances } from './computed'
import type { Action } from './actions'
import type { SwitcherStoreState } from './store'

export const getUpdated = (anyProps: Record<string, any> | null | undefined, curProps: Record<string, any>): Record<string, any> | undefined => {
  if (!anyProps) {
    return
  }
  if (!curProps || anyProps[''] === getUpdated) { // skip duplicated processing
    return anyProps
  }
  let changed = false
  const updated = Object.keys(anyProps).reduce((o, key) => {
    if (curProps[key] !== anyProps[key]) {
      o[key] = anyProps[key]
      changed = true
    }
    return o
  }, {} as any) as Partial<SwitcherStoreState>
  if (changed) {
    return Object.defineProperties(updated, {
      '': { value: getUpdated },
    })
  }
}

const reducer = (state: SwitcherStoreState, action: Action): SwitcherStoreState => {
  switch (action.type) {
    case 'update-props': {
      const updated = getUpdated(action.props, state as Record<string, any>)
      if (updated) {
        return { ...state, ...updated }
      }
      return state
    }
    case 'get-current-portal-display-app-id': {
      const currentPortalDisplayAppId = getCurrentPortalDisplayAppId()
      if (state.currentPortalDisplayAppId !== currentPortalDisplayAppId) {
        const newState = { ...state, currentPortalDisplayAppId }
        newState.tsgAppInstances = getSortedAppInstances(newState)
        return newState
      }
      return state
    }
    case 'set-open': {
      if (state.disabled) {
        return state.isOpen ? { ...state, isOpen: false } : state
      }
      if (action.isOpen !== state.isOpen) {
        return { ...state, isOpen: action.isOpen }
      }
      return state
    }
    case 'set-tsg': {
      const tsg = action.tsg_id ? state.tsgs.get(action.tsg_id) : undefined
      if (tsg !== state.tsg) {
        return { ...state, tsg }
      }
      return state
    }
    case 'set-instances': {
      if (!action.instances) {
        if (state.instances || state.tsgAppInstances) {
          return { ...state, instances: undefined, tsgAppInstances: undefined }
        }
      }
      else if (action.instances.tsg_id !== state.tsg?.id) {
        return state
      }
      else if (!state.tsgAppInstances?.length || !_.isEqual(action.instances, state.instances)) {
        const newState = {
          ...state,
          instances: action.instances,
        }
        newState.tsgAppInstances = getSortedAppInstances(newState)
        return newState
      }
      return state
    }
    default:
      throw new Error('unknown action')
  }
}

export default reducer
